// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full page layout for mandatory 2FA setup */
.twofa-setup-page {
  min-height: 100vh;
  background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* Center the card and keep it within one screen — no page scroll. */
  padding: 24px 20px;
  position: relative;
  overflow: hidden;
}

.twofa-setup-page::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: float 20s ease-in-out infinite;
}

@keyframes float {

  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }

  50% {
    transform: translate(-20px, 20px) rotate(180deg);
  }
}

.twofa-setup-page .page_logo {
  width: 100%;
  max-width: 540px;
  text-align: center;
  margin-bottom: 20px;
  position: relative;
  z-index: 10;
}

.twofa-setup-page .page_logo a {
  display: inline-block;
  text-decoration: none;
}

.twofa-setup-page .page_logo img {
  max-width: 200px;
  width: auto;
  height: auto;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
  transition: transform 0.3s ease;
}

.twofa-setup-page .page_logo img:hover {
  transform: scale(1.05);
}

.twofa-setup-content-page {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 22px 36px 26px;
  max-width: 460px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.5);
  position: relative;
  animation: slideUp 0.5s ease-out;
}

/* Back link in the top-left corner (frees vertical space vs a stacked button). */
.twofa-corner-back {
  position: absolute;
  top: 16px;
  left: 18px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  padding: 6px 8px;
  margin: 0;
  border-radius: 8px;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s ease, background 0.2s ease;
  z-index: 3;
}

.twofa-corner-back:hover {
  color: #4346ce;
  background: #f1f3ff;
}

.twofa-corner-back:hover .back-arrow {
  transform: translateX(-3px);
}

/* Subtle skip link under the primary button. */
.twofa-skip-link {
  display: block;
  margin: 14px auto 0;
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 8px;
  transition: color 0.2s ease;
}

.twofa-skip-link:hover {
  color: #64748b;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.twofa-setup-content-page .twofa-step {
  text-align: center;
}

.twofa-setup-content-page .mandatory-notice {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #92400e;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 12.5px;
  font-weight: 600;
  margin-bottom: 14px;
  border: 1px solid #fcd34d;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.twofa-back-btn {
  margin-top: 16px;
  background: none;
  border: none;
  color: #64748b;
  font-size: 14px;
  cursor: pointer;
  padding: 10px 20px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
  font-weight: 500;
  width: 100%;
}

.twofa-back-btn:hover {
  color: #4346ce;
  background: #f8fafc;
}

.back-arrow {
  transition: transform 0.2s ease;
}

.twofa-back-btn:hover .back-arrow {
  transform: translateX(-3px);
}

/* Modal layout for optional setup */
.twofa-setup-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.twofa-setup-content {
  background: white;
  border-radius: 16px;
  padding: 40px;
  max-width: 480px;
  width: 100%;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
}

.twofa-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
}

.twofa-close-btn:hover {
  color: #333;
}

.twofa-step {
  text-align: center;
}

.twofa-setup-icon-wrapper {
  position: relative;
  width: 56px;
  height: 56px;
  margin: 8px auto 12px;
}

.twofa-setup-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  box-shadow: 0 6px 16px rgba(67, 70, 206, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.twofa-setup-icon svg {
  font-size: 24px;
  color: white;
}

.twofa-icon-pulse {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 18px;
  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);
  opacity: 0.25;
  animation: pulse 2.4s ease-out infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.3;
  }

  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.twofa-step h2 {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 8px;
  letter-spacing: -0.4px;
}

.twofa-step>p {
  color: #64748b;
  font-size: 13.5px;
  margin: 0 0 16px;
  line-height: 1.5;
}

.twofa-benefits {
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border: 1px solid #e0e7ff;
  border-radius: 14px;
  padding: 12px 16px;
  margin-bottom: 18px;
  text-align: left;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 6px 0;
  color: #1e293b;
  font-size: 13.5px;
  font-weight: 500;
}

.benefit-item svg {
  color: #10b981;
  font-size: 18px;
  flex-shrink: 0;
}

.qr-container {
  background: white;
  border: 3px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  margin: 0 auto 24px;
  display: inline-block;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.qr-container img {
  width: 220px;
  height: 220px;
  display: block;
}

.manual-entry {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 20px;
  margin-bottom: 28px;
}

.manual-entry p {
  font-size: 14px;
  color: #64748b;
  margin: 0 0 14px;
  font-weight: 500;
}

.secret-key {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 18px;
  transition: all 0.2s ease;
}

.secret-key:hover {
  border-color: #cbd5e1;
}

.secret-key code {
  font-family: 'Courier New', monospace;
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: 1.5px;
  word-break: break-all;
  flex: 1 1;
}

.secret-key button {
  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px 12px;
  font-size: 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.secret-key button:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(67, 70, 206, 0.4);
}

.twofa-setup-content .code-inputs {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 32px;
  position: relative;
}

.twofa-setup-content .code-inputs input {
  width: 54px;
  height: 64px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  background: #ffffff;
  color: #1e293b;
  caret-color: #4346ce;
}

.twofa-setup-content .code-inputs input:focus {
  border-color: #4346ce;
  box-shadow: 0 0 0 4px rgba(67, 70, 206, 0.12);
  transform: scale(1.05);
}

.twofa-setup-content .code-inputs input.filled {
  border-color: #4346ce;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
}

.twofa-setup-content .code-inputs input.error {
  border-color: #ef4444;
  animation: shake 0.4s cubic-bezier(0.36, 0.07, 0.19, 0.97);
  background: #fef2f2;
}

.twofa-setup-content .code-inputs input:disabled {
  background: #f8fafc;
  cursor: not-allowed;
  opacity: 0.6;
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-8px);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translateX(8px);
  }
}

.twofa-error {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #dc2626;
  font-size: 14px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fecaca;
  border-radius: 12px;
  animation: errorSlide 0.3s ease-out;
}

@keyframes errorSlide {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.twofa-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 8px;
}

.twofa-primary-btn {
  padding: 13px 36px;
  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);
  color: white;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 160px;
  box-shadow: 0 4px 16px rgba(67, 70, 206, 0.4);
  position: relative;
  overflow: hidden;
}

.twofa-primary-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.twofa-primary-btn:hover:not(:disabled)::before {
  left: 100%;
}

.twofa-primary-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(67, 70, 206, 0.5);
}

.twofa-primary-btn:active:not(:disabled) {
  transform: translateY(0);
}

.twofa-primary-btn:disabled {
  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.6;
}

.twofa-secondary-btn {
  padding: 16px 36px;
  background: white;
  color: #4346ce;
  border: 2px solid #4346ce;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
}

.twofa-secondary-btn:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(67, 70, 206, 0.2);
}

@media (max-width: 480px) {
  .twofa-setup-content-page {
    padding: 30px 22px;
    border-radius: 20px;
  }

  .twofa-setup-content {
    padding: 30px 20px;
  }

  .twofa-setup-icon-wrapper {
    width: 56px;
    height: 56px;
  }

  .twofa-setup-icon {
    width: 56px;
    height: 56px;
  }

  .twofa-setup-icon svg {
    font-size: 24px;
  }

  .twofa-step h2 {
    font-size: 24px;
  }

  .twofa-setup-content .code-inputs input {
    width: 46px;
    height: 56px;
    font-size: 24px;
  }

  .twofa-setup-content .code-inputs {
    gap: 8px;
  }

  .qr-container img {
    width: 180px;
    height: 180px;
  }

  .twofa-buttons {
    flex-direction: column;
  }

  .twofa-primary-btn,
  .twofa-secondary-btn {
    width: 100%;
  }
}

@media (max-width: 360px) {
  .twofa-setup-page .page_logo img {
    max-width: 160px;
  }

  .twofa-setup-content .code-inputs input {
    width: 40px;
    height: 50px;
    font-size: 20px;
  }

  .qr-container img {
    width: 160px;
    height: 160px;
  }
}

.twofa-recovery-box {
  text-align: left;
  margin: 16px 0;
}

.twofa-recovery-pre {
  background: #f4f4f7;
  border: 1px solid #e2e2ea;
  border-radius: 8px;
  padding: 14px;
  font-size: 13px;
  line-height: 1.6;
  overflow-x: auto;
  max-height: 220px;
  margin: 0 0 12px 0;
  white-space: pre-wrap;
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/components/auth/TwoFactorSetup.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,4GAA4G;EAC5G,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oEAAoE;EACpE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,yCAAyC;AAC3C;;AAEA;;EAEE;;IAEE,uCAAuC;EACzC;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,+EAA+E;EAC/E,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,+CAA+C;AAC/C;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,uFAAuF;AACzF;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;;;;;IAKE,2BAA2B;EAC7B;;EAEA;;;;IAIE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB","sourcesContent":["/* Full page layout for mandatory 2FA setup */\n.twofa-setup-page {\n  min-height: 100vh;\n  background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  /* Center the card and keep it within one screen — no page scroll. */\n  padding: 24px 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.twofa-setup-page::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);\n  animation: float 20s ease-in-out infinite;\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n\n  50% {\n    transform: translate(-20px, 20px) rotate(180deg);\n  }\n}\n\n.twofa-setup-page .page_logo {\n  width: 100%;\n  max-width: 540px;\n  text-align: center;\n  margin-bottom: 20px;\n  position: relative;\n  z-index: 10;\n}\n\n.twofa-setup-page .page_logo a {\n  display: inline-block;\n  text-decoration: none;\n}\n\n.twofa-setup-page .page_logo img {\n  max-width: 200px;\n  width: auto;\n  height: auto;\n  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));\n  transition: transform 0.3s ease;\n}\n\n.twofa-setup-page .page_logo img:hover {\n  transform: scale(1.05);\n}\n\n.twofa-setup-content-page {\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n  padding: 22px 36px 26px;\n  max-width: 460px;\n  width: 100%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.5);\n  position: relative;\n  animation: slideUp 0.5s ease-out;\n}\n\n/* Back link in the top-left corner (frees vertical space vs a stacked button). */\n.twofa-corner-back {\n  position: absolute;\n  top: 16px;\n  left: 18px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: none;\n  border: none;\n  padding: 6px 8px;\n  margin: 0;\n  border-radius: 8px;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: color 0.2s ease, background 0.2s ease;\n  z-index: 3;\n}\n\n.twofa-corner-back:hover {\n  color: #4346ce;\n  background: #f1f3ff;\n}\n\n.twofa-corner-back:hover .back-arrow {\n  transform: translateX(-3px);\n}\n\n/* Subtle skip link under the primary button. */\n.twofa-skip-link {\n  display: block;\n  margin: 14px auto 0;\n  background: none;\n  border: none;\n  color: #94a3b8;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 4px 10px;\n  border-radius: 8px;\n  transition: color 0.2s ease;\n}\n\n.twofa-skip-link:hover {\n  color: #64748b;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.twofa-setup-content-page .twofa-step {\n  text-align: center;\n}\n\n.twofa-setup-content-page .mandatory-notice {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  color: #92400e;\n  padding: 10px 14px;\n  border-radius: 12px;\n  font-size: 12.5px;\n  font-weight: 600;\n  margin-bottom: 14px;\n  border: 1px solid #fcd34d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.twofa-back-btn {\n  margin-top: 16px;\n  background: none;\n  border: none;\n  color: #64748b;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 10px 20px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 10px;\n  font-weight: 500;\n  width: 100%;\n}\n\n.twofa-back-btn:hover {\n  color: #4346ce;\n  background: #f8fafc;\n}\n\n.back-arrow {\n  transition: transform 0.2s ease;\n}\n\n.twofa-back-btn:hover .back-arrow {\n  transform: translateX(-3px);\n}\n\n/* Modal layout for optional setup */\n.twofa-setup-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.twofa-setup-content {\n  background: white;\n  border-radius: 16px;\n  padding: 40px;\n  max-width: 480px;\n  width: 100%;\n  position: relative;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.twofa-close-btn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #999;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n}\n\n.twofa-close-btn:hover {\n  color: #333;\n}\n\n.twofa-step {\n  text-align: center;\n}\n\n.twofa-setup-icon-wrapper {\n  position: relative;\n  width: 56px;\n  height: 56px;\n  margin: 8px auto 12px;\n}\n\n.twofa-setup-icon {\n  width: 56px;\n  height: 56px;\n  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 2;\n  box-shadow: 0 6px 16px rgba(67, 70, 206, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.25);\n}\n\n.twofa-setup-icon svg {\n  font-size: 24px;\n  color: white;\n}\n\n.twofa-icon-pulse {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 18px;\n  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);\n  opacity: 0.25;\n  animation: pulse 2.4s ease-out infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.3;\n  }\n\n  100% {\n    transform: scale(1.5);\n    opacity: 0;\n  }\n}\n\n.twofa-step h2 {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 8px;\n  letter-spacing: -0.4px;\n}\n\n.twofa-step>p {\n  color: #64748b;\n  font-size: 13.5px;\n  margin: 0 0 16px;\n  line-height: 1.5;\n}\n\n.twofa-benefits {\n  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);\n  border: 1px solid #e0e7ff;\n  border-radius: 14px;\n  padding: 12px 16px;\n  margin-bottom: 18px;\n  text-align: left;\n}\n\n.benefit-item {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 6px 0;\n  color: #1e293b;\n  font-size: 13.5px;\n  font-weight: 500;\n}\n\n.benefit-item svg {\n  color: #10b981;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.qr-container {\n  background: white;\n  border: 3px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 24px;\n  margin: 0 auto 24px;\n  display: inline-block;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.qr-container img {\n  width: 220px;\n  height: 220px;\n  display: block;\n}\n\n.manual-entry {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 20px;\n  margin-bottom: 28px;\n}\n\n.manual-entry p {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0 0 14px;\n  font-weight: 500;\n}\n\n.secret-key {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 14px 18px;\n  transition: all 0.2s ease;\n}\n\n.secret-key:hover {\n  border-color: #cbd5e1;\n}\n\n.secret-key code {\n  font-family: 'Courier New', monospace;\n  font-size: 15px;\n  font-weight: 700;\n  color: #1e293b;\n  letter-spacing: 1.5px;\n  word-break: break-all;\n  flex: 1;\n}\n\n.secret-key button {\n  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);\n  border: none;\n  color: white;\n  cursor: pointer;\n  padding: 8px 12px;\n  font-size: 16px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.secret-key button:hover {\n  transform: scale(1.05);\n  box-shadow: 0 2px 8px rgba(67, 70, 206, 0.4);\n}\n\n.twofa-setup-content .code-inputs {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  margin-bottom: 32px;\n  position: relative;\n}\n\n.twofa-setup-content .code-inputs input {\n  width: 54px;\n  height: 64px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 28px;\n  font-weight: 700;\n  text-align: center;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  outline: none;\n  background: #ffffff;\n  color: #1e293b;\n  caret-color: #4346ce;\n}\n\n.twofa-setup-content .code-inputs input:focus {\n  border-color: #4346ce;\n  box-shadow: 0 0 0 4px rgba(67, 70, 206, 0.12);\n  transform: scale(1.05);\n}\n\n.twofa-setup-content .code-inputs input.filled {\n  border-color: #4346ce;\n  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);\n}\n\n.twofa-setup-content .code-inputs input.error {\n  border-color: #ef4444;\n  animation: shake 0.4s cubic-bezier(0.36, 0.07, 0.19, 0.97);\n  background: #fef2f2;\n}\n\n.twofa-setup-content .code-inputs input:disabled {\n  background: #f8fafc;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n@keyframes shake {\n\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translateX(-8px);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translateX(8px);\n  }\n}\n\n.twofa-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #dc2626;\n  font-size: 14px;\n  margin-bottom: 20px;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  border: 1px solid #fecaca;\n  border-radius: 12px;\n  animation: errorSlide 0.3s ease-out;\n}\n\n@keyframes errorSlide {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.twofa-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.twofa-primary-btn {\n  padding: 13px 36px;\n  background: linear-gradient(135deg, #4346ce 0%, #4346ce 100%);\n  color: white;\n  border: none;\n  border-radius: 14px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  min-width: 160px;\n  box-shadow: 0 4px 16px rgba(67, 70, 206, 0.4);\n  position: relative;\n  overflow: hidden;\n}\n\n.twofa-primary-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.twofa-primary-btn:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.twofa-primary-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(67, 70, 206, 0.5);\n}\n\n.twofa-primary-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.twofa-primary-btn:disabled {\n  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);\n  cursor: not-allowed;\n  box-shadow: none;\n  opacity: 0.6;\n}\n\n.twofa-secondary-btn {\n  padding: 16px 36px;\n  background: white;\n  color: #4346ce;\n  border: 2px solid #4346ce;\n  border-radius: 14px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 140px;\n}\n\n.twofa-secondary-btn:hover {\n  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(67, 70, 206, 0.2);\n}\n\n@media (max-width: 480px) {\n  .twofa-setup-content-page {\n    padding: 30px 22px;\n    border-radius: 20px;\n  }\n\n  .twofa-setup-content {\n    padding: 30px 20px;\n  }\n\n  .twofa-setup-icon-wrapper {\n    width: 56px;\n    height: 56px;\n  }\n\n  .twofa-setup-icon {\n    width: 56px;\n    height: 56px;\n  }\n\n  .twofa-setup-icon svg {\n    font-size: 24px;\n  }\n\n  .twofa-step h2 {\n    font-size: 24px;\n  }\n\n  .twofa-setup-content .code-inputs input {\n    width: 46px;\n    height: 56px;\n    font-size: 24px;\n  }\n\n  .twofa-setup-content .code-inputs {\n    gap: 8px;\n  }\n\n  .qr-container img {\n    width: 180px;\n    height: 180px;\n  }\n\n  .twofa-buttons {\n    flex-direction: column;\n  }\n\n  .twofa-primary-btn,\n  .twofa-secondary-btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 360px) {\n  .twofa-setup-page .page_logo img {\n    max-width: 160px;\n  }\n\n  .twofa-setup-content .code-inputs input {\n    width: 40px;\n    height: 50px;\n    font-size: 20px;\n  }\n\n  .qr-container img {\n    width: 160px;\n    height: 160px;\n  }\n}\n\n.twofa-recovery-box {\n  text-align: left;\n  margin: 16px 0;\n}\n\n.twofa-recovery-pre {\n  background: #f4f4f7;\n  border: 1px solid #e2e2ea;\n  border-radius: 8px;\n  padding: 14px;\n  font-size: 13px;\n  line-height: 1.6;\n  overflow-x: auto;\n  max-height: 220px;\n  margin: 0 0 12px 0;\n  white-space: pre-wrap;\n  word-break: break-all;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
